export default "__VITE_ASSET__B_$woNpB__"